import { fromJS } from 'immutable';
import { createSelector } from 'reselect';

// ACTION TYPES
export const SET_LOGIN_FLOW_COMPLETE = 'customer-portal/unsavedApp/SET_LOGIN_FLOW_COMPLETE';

// ACTION CREATORS
// We use this method because we want to know if this is a first time login without refresh
// We do not do this inside the authentication module because the authentication module is rehydrated after refresh
export const setLoginFlowComplete = isComplete => ({
  type: SET_LOGIN_FLOW_COMPLETE,
  payload: isComplete,
});

export const initialState = fromJS({
  loginFlowIsComplete: false,
});

// SELECTORS
const appSelector = state => state.unsavedApp;

export const getLoginFlowIsComplete = createSelector([appSelector], app => app.get('loginFlowIsComplete'));

// REDUCER
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOGIN_FLOW_COMPLETE:
      return state.set('loginFlowIsComplete', action.payload);
    default:
      return state;
  }
};
